const attributes = {
  marquee: "data-promo-marquee",
};

class JsMarquee extends HTMLElement {
  _initialContent;
  _$marqueeElement;
  _width = 0;

  constructor() {
    super();
    this.debounce = this.debounce.bind(this);
  }

  connectedCallback() {
    this._$marqueeElement = this.querySelector(`[${attributes.marquee}]`);
    if (!this._$marqueeElement) return;

    if (!this._initialContent) {
      this._initialContent = this._$marqueeElement.innerHTML;
    }
    if (!this._initialContent) return;

    window.addEventListener("resize", this.debounce(this.init.bind(this), 1000));
    this.init();
  }

  init() {
    if (window.innerWidth === this._width) {
      return;
    }
    this._width = window.innerWidth;

    this.removeAttribute("ready");

    this._$marqueeElement.innerHTML = "";

    for (let safeCounter = 0; safeCounter < 100; safeCounter++) {
      if (this._$marqueeElement.scrollWidth > window.innerWidth) break;
      this._$marqueeElement.innerHTML += this._initialContent;
    }
    this._$marqueeElement.innerHTML += this._$marqueeElement.innerHTML;

    this.style.setProperty(
      "--promo-marquee-speed",
      `${this._$marqueeElement.scrollWidth / 100}s`
    );
    this.setAttribute("ready", "");
  }

  debounce(func, wait) {
    let timeout;
    return function(...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }
}
if (customElements.get("js-marquee") === undefined) {
  customElements.define("js-marquee", JsMarquee);
}